import { createAccessControl } from "better-auth/plugins/access";
import { defaultStatements, adminAc, memberAc, ownerAc, } from "better-auth/plugins/organization/access";
/**
 * Access control for the Coach Organizer multi-tenant model.
 *
 * The product calls invited members "coaches" — internally we register `coach`
 * as a custom role with the same permission set as the built-in `member` role.
 * Owners remain the only role that can mutate the organization itself, invite
 * other members, or delete things.
 *
 * NOTE: the same `ac` + `roles` map MUST be passed to both the server
 * `organization()` plugin and the client `organizationClient()` plugin so the
 * TypeScript literal-union for `role` accepts our custom name.
 *
 * We deliberately widen `ac`'s exported type to the generic `AccessControl` so
 * passing it to `organization({ ac })` / `organizationClient({ ac })` doesn't
 * trip TS's contravariant function-parameter check (the plugin types `ac` as
 * the generic `AccessControl`, but a narrowly-typed `ac` is — by variance —
 * not assignable to that wider type).
 */
const statement = {
    ...defaultStatements,
};
const _ac = createAccessControl(statement);
export const owner = _ac.newRole({
    ...ownerAc.statements,
});
export const admin = _ac.newRole({
    ...adminAc.statements,
});
export const member = _ac.newRole({
    ...memberAc.statements,
});
// `coach` is intentionally identical to `member` for now — it exists so the
// product can use coach terminology end-to-end without leaking Better Auth's
// default vocabulary.
export const coach = _ac.newRole({
    ...memberAc.statements,
});
export const ac = _ac;
export const roles = { owner, admin, member, coach };
//# sourceMappingURL=access.js.map